<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState, mapActions } from "vuex";
import { event } from "vue-analytics";
import moment from "@/utils/moment";

import Card from "@/components/_Shared/Professionals/Card";
import Feedbacks from "@/components/_Shared/Professionals/Feedbacks/Index";
import InputGroup from "@/components/_Shared/InputGroup";
import dateMixin from "@/mixins/dateMixin";

export default {
  mixins: [dateMixin],
  components: {
    swiper,
    swiperSlide,
    Card,
    Feedbacks,
    InputGroup
  },

  props: {
    title: {
      type: String,
      required: false
    },
    searchInput: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 0,
        centerInsufficientSlides: true,
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        breakpoints: {
          530: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            centeredSlides: true
          },
          730: {
            slidesPerView: 2,
            slidesPerGroup: 2
          }
        }
      },
      search: "",
      filtered_professionals: [],
      professionalFeedbacks: null
    };
  },

  computed: {
    ...mapState("newOrder", ["professionals_available", "to_be", "day"]),
    ...mapState("professionalsSuggestion", ["availableEvents"]),
    professionalSelected() {
      return this.$store.state.newOrder.professional;
    },
    suggestionsLoading() {
      return this.$store.state.professionalsSuggestion.loader;
    }
  },

  methods: {
    ...mapActions("newOrder", ["setProfessional"]),

    sortProfessionalsByRating(professionals) {
      if (professionals && professionals.length)
        professionals.sort((a, b) => (a.rating < b.rating ? 1 : -1));
    },

    filter_professionals() {
      if (!this.professionals_available) return;

      this.setProfessional(null);
      let regex = new RegExp(this.search, "i");

      this.filtered_professionals = this.professionals_available.filter(
        professional => {
          return (
            regex.test(professional.account.first_name) ||
            regex.test(professional.account.last_name)
          );
        }
      );

      this.sortProfessionalsByRating(this.filtered_professionals);
    },

    selectProfessional(professional) {
      event(
        "cliente",
        "click",
        `Compra:${this.to_be}:profissional:selecionado=${
          professional.account.first_name
        } ${professional.account.last_name}`
      );
      this.setProfessional(professional);
      this.$emit("professionalSelected");
    },

    userInteraction() {
      this.$emit("userInteraction");
    },

    setProfessionalFeedbacks(professional) {
      this.professionalFeedbacks = professional;
      this.userInteraction();
    }
  },

  watch: {
    professionals_available(professionals) {
      this.filter_professionals();
    },
    search() {
      this.userInteraction();
    }
  },

  mounted() {
    this.filter_professionals();
  }
};
</script>

<template>
  <div
    id="professionals"
    class="professionals"
    v-if="professionals_available !== null && !professionals_available.length"
  >
    <span v-if="to_be === 'schedule'">
      <div v-if="title" class="section-title">
        {{title}}
        <hr />
      </div>
      Ops! Não encontramos profissionais disponíveis para o dia e horário informado.
    </span>
    <span v-else>Ops! Não encontramos profissionais disponíveis com o nome informado</span>
  </div>

  <div id="professionals" class="section" v-else-if="professionals_available !== null && professionals_available.length > 0">
    <div v-if="title" class="section-title">
      {{title}}
      <hr />
    </div>

    <div class="professionals-body" v-if="filtered_professionals.length">
      <swiper :options="swiperOption" @slideChange="userInteraction()" ref="mySwiper">
        <swiper-slide v-for="professional in filtered_professionals" :key="professional.id">
          <div class="professionals-card" >
            <card
              :professional="professional"
              :checked="professionalSelected && professional.id === professionalSelected.id"
              class="mb-20"
              @selected="selectProfessional($event)"
              v-on:showfeedbacks="setProfessionalFeedbacks(professional)" 
            >
              <div
                class="btn btn-rounded btn-small bg-gray mt-10"
                @click.stop="setProfessionalFeedbacks(professional)"
              >ver avaliações</div>
            </card>
          </div>
        
        </swiper-slide>

        <div class="swiper-button-prev" slot="button-prev" ></div>
        <div class="swiper-button-next" slot="button-next" ></div>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <span class="drag-text">arraste para o lado</span>
    </div>
    
    <feedbacks
      v-if="professionalFeedbacks"
      :professional="professionalFeedbacks"
      @close="professionalFeedbacks = null"
    />

  </div>
</template>

<style scoped>
.no-professionals {
  font-size: 14px;
  color: var(--pink);
}

.drag-text {
  display: none;
  color: #888;
  font-size: 11px;
  font-style: italic;
}

.wpp {
  flex-direction: row;
  font-size: 14px;
}

.wpp img {
  height: 18px;
  margin-bottom: 0;
}

span {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
}

.professionals-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.professionals {
  text-align: center;
}

.professionals-body {
  width: 600px;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.swiper-container {
  width: 100%;
  text-align: center;
}

.swiper-button-prev {
  background-image: url("/static/arrow-prev.svg") !important;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0 !important;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0 !important;
}

.swiper-button-next {
  background-image: url("/static/arrow-next.svg") !important;
}

.section,
.professionals-body {
  width: 100%;
}

@media (max-width: 630px) {
  .drag-text {
    display: block;
  }

  .wpp {
    flex-direction: column-reverse;
  }

  .wpp img {
    height: 18px;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/Professionals.vue